import React from 'react';

import CellSaveButtons from './CellSaveButtons';

class CheckboxWithButtons extends React.Component {
    inputEl = React.createRef();

    componentDidMount() {
        this.inputEl.current.focus();
    }

    cancelHandler = () => {
        this.props.onBlur();
        this.props.onCancel();
    }

    render = () => {
        const {onUpdate, defaultValue, className} = this.props;
        return (
            <div className="edit-wrapper input-with-buttons">
                <div className="field-wrapper field-wrapper-checkbox">
                    <input defaultChecked={defaultValue} type="checkbox" ref={this.inputEl}
                           className={className}/>
                </div>
                <CellSaveButtons
                    onSave={() => onUpdate(this.inputEl.current.checked)}
                    onCancel={this.cancelHandler}
                />
            </div>
        );
    }
}

export default CheckboxWithButtons;
